<template>
  <v-expansion-panels
    :value="expanded"
    :readonly="!isExpandable"
    flat
    >
    <v-expansion-panel :id="'post-assessment-expansion-panel-' + headerToken" class="my-2 conditions assessment-light panel-opaque">
      <v-expansion-panel-header class="intro-dark pa-4">
        <v-row align="center" no-gutters>
          <v-col cols="1">
            <v-icon :v-if="headerIcon !== null" large :color="headerIconColor">
              {{ headerIcon }}
            </v-icon>
          </v-col>

          <v-col :class="headerClass">
            <mrx-translation :token="headerToken"></mrx-translation>
          </v-col>
        </v-row>
        <template v-slot:actions>
          <v-icon large v-show="isExpandable">
            {{ icons.mdiChevronDown }}
          </v-icon>
        </template>
        <v-col cols="1" v-if="!isExpandable"></v-col>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <v-layout column>
          <v-flex
            v-for="(contentItem, index) in contentList"
            :key="`${contentItem.name}_${contentItem.headerToken}`"
          >
          <v-tooltip
            :disabled="!tooltipVisibility[contentItem.name]"
            bottom
          >
          <template v-slot:activator="{ on, attrs }">
            <div
            @mouseover="tooltipVisibility[contentItem.name] = disabledItems[contentItem.name] ? true : false"
            @mouseleave="tooltipVisibility[contentItem.name] = false"
            v-on="on" v-bind="attrs">
            <v-layout
              :id="'post-assessment-selection-' + contentItem.name"
              class="my-3"
              :class="{ 'is-disabled': disabledItems[contentItem.name] }"
              @click="select(contentItem.name)"
            >
              <div style="position: relative">
              <v-icon
                v-if="isChecklist"
                size=28
                color="primary"
                class="me-3"
              >
                {{ checkboxIcon(contentItem.name) }}
              </v-icon>
            </div>

              <v-flex xs11 align-self-center>
                <div style="line-height: normal">
                  <mrx-translation
                    v-if="contentItem.headerToken"
                    class="treatment-header"
                    :token="contentItem.headerToken"
                  >
                  </mrx-translation>

                  <div v-for="(item, index) in contentItem.detailContent"
                    :key="item+'_'+index"
                    >
                    <mrx-translation
                      v-if="!contentItem.useHTMLFormat"
                      class="assessment-light" :class="(contentItem.headerToken) ? 'treatment-text' : 'treatment-header'"
                      :token="item"
                    ></mrx-translation>
                    <span v-else class="assessment-light" :class="(contentItem.headerToken) ? 'treatment-text' : 'treatment-header'" v-html="item"></span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </div>
            </template>
            <span v-if="disabledItems[contentItem.name]">
              <mrx-translation :token="disabledItems[contentItem.name].token"></mrx-translation>
            </span>
          </v-tooltip>
            <v-divider
              class="me-3"
              v-if="index < contentList.length - 1"
              :key="index"
            ></v-divider>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import icons from "@/mixins/icons"
import ui from "@/mixins/ui"

export default {
  name: "PostAssessmentCard",
  mixins: [icons, ui],
  props: {
    headerToken: String,
    headerIcon: String,
    headerIconColor: String,
    contentList: Array,
    isChecklist: {type: Boolean, default: false},
    isExpandable: {type: Boolean, default: false},
    defaultExpanded: {type: Boolean, default: true},
    value: Array,
    disabledItems: {type: Object, default: () => ({})}
  },
  data() {
    return {
      selected: this.value,
      tooltipVisibility: {}, // Object to hold visibility state for each tooltip
    };
  },
  computed: {
    expanded() {
      return this.defaultExpanded ? 0 : null
    },
    headerClass() {
      if (this.isExpandable) {
        return 'post-assessment-header ps-4'
      } else {
        return 'post-assessment-header px-2 ms-2'
      }
    }
  },
  watch: {
    value() {
      this.selected = this.value
    },
    contentList: {
      immediate: true,
      handler(newList) {
        newList.forEach(item => {
          if (!(item.name in this.tooltipVisibility)) {
            this.$set(this.tooltipVisibility, item.name, false);
          }
        });
      }
    }
  },
  methods: {
    itemIsSelected(name) {
      return this.selected.includes(name)
    },
    select(name) {
      if (this.isChecklist && !this.disabledItems[name]) {
        if (this.itemIsSelected(name)) {
          this.selected = this.selected.filter(selected => selected !== name)
        } else {
          this.selected.push(name)
        }
        this.$emit('handleInput', this.selected)
      }
    },
    checkboxIcon(name) {
      if (this.itemIsSelected(name)) {
        return this.icons.mdiCheckboxOutline
      } else {
        return this.icons.mdiCheckboxBlankOutline
      }
    }
  },
};
</script>

<style scoped>
  .is-disabled {
    opacity: 0.33;
    pointer-events: none; /* Disable mouse events */
  }
  .v-expansion-panel-header:not(.v-expansion-panel-header--active) {
    border-radius: 16px;
    transition: border-radius .4s;
  }
</style>
